import jwtDecode from 'jwt-decode';
import type { CustomAudiencesApiContext } from '../types';

/** The access token claim proxima-nestjs-commons `JwtMiddleware` reads as the user id, which proxima-audiences stores as `createdByUserId`. */
export const USER_ID_CLAIM = 'https://dojomojo.com/jwt/userId';

/** The user id claim of an access token, or null when the token does not decode or carries no id. */
export const userIdFromToken = (token: string): string | null => {
  try {
    const id = jwtDecode<Record<string, unknown>>(token)[USER_ID_CLAIM];
    return typeof id === 'string' && id ? id : null;
  } catch {
    return null;
  }
};

/** The signed-in user's id from `ctx`'s token, or null when the token cannot be read. */
export const currentUserId = async (ctx: CustomAudiencesApiContext): Promise<string | null> => {
  try {
    return userIdFromToken(await ctx.getToken());
  } catch {
    return null;
  }
};
